import React from 'react';

const namespace = 'ui-search-item__group__element-separator';

const Separator = () => <hr className={namespace} />;

Separator.propTypes = {};

export default Separator;
